<template>
  <navigation-button
    icon="plus"
    label="Nova regra"
    :href="href"
  />
</template>

<script>
  import NavigationButton from '@/components/Navigation/Button.vue';

  export default {
    name: 'CommercialSettingsButtons',
    components: {
      NavigationButton,
    },
    computed: {
      href() {
        return {
          name: this.$route.meta.new,
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';
</style>
